import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { CtaButton } from "@/components/cta/CtaButton";
import SectionAtmosphere from "@/components/SectionAtmosphere";
import atmospherePrinciples from "@/assets/atmosphere-principles.jpg";
import { lqipFor } from "@/generated/atmospheric-lqip";
import { riseFade } from "@/lib/motion";
import { openRequestAccess } from "./RequestAccessDialog";

const Principles = () => (
  <SectionAtmosphere
    id="principles"
    ariaLabelledBy="principles-heading"
    src={atmospherePrinciples}
    optimizedBase="/opt/atmosphere-principles"
    lqip={lqipFor(atmospherePrinciples)}
    origin="center"
    intensity={0.1}
    glow="center"
    tone="muted"
    className="py-28 sm:py-36"
  >
    <div className="container mx-auto px-6 sm:px-10 lg:px-16">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-10% 0px" }}
        variants={riseFade}
        className="max-w-3xl mx-auto text-center space-y-8"
      >
        <div className="eyebrow justify-center mx-auto">Founder Mode</div>
        <h2
          id="principles-heading"
          className="font-display text-foreground text-display-2xl"
        >
          Reduce. Decide. <span className="italic text-primary">Move on.</span>
        </h2>
        <p className="lead-italic max-w-2xl mx-auto">
          Protect decisions over productivity. Every screen, every prompt has to earn its place, or it doesn't ship.
        </p>
        <div className="max-w-2xl mx-auto space-y-3 pt-2">
          <div className="text-[10px] tracking-[0.32em] uppercase text-primary">
            It tells you when it's wrong
          </div>
          <p className="text-muted-foreground leading-relaxed">
            A card in the app shows how often the morning read actually matched your day, hits and misses. No other app in this space shows you that.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-6">
          <Link to="/blog" aria-label="Read the philosophy, visit the blog">
            <Button variant="outline" size="lg" className="group w-full sm:w-auto px-8 min-h-11" tabIndex={-1}>
              Read the philosophy
              <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </Button>
          </Link>
          <CtaButton
            intent="requestAccess"
            source="principles"
            className="w-full sm:w-auto px-8"
            onClick={() => openRequestAccess("principles")}
          />
        </div>
      </motion.div>
    </div>
  </SectionAtmosphere>
);

export default Principles;
